// Lightweight class-name joiner — avoids any dependency on clsx/classnames.
// Usage: cn('base', condition && 'extra', other)
export const cn = (...classes: (string | false | null | undefined)[]): string =>
  classes.filter(Boolean).join(' ')
